import { Grade } from "../../models/enums/grade";
import { ResetableRadioGroup } from "./ResetableRadio";

type GradeRadio = {
  value?: string;
  defaultValue?: string;
  onChange: (selected: string) => void;
  onReset: () => void;
  resetLabel?: string;
  translation?: (grade: Grade) => string;
  radioFlex?: number;
  selfAssessmentValue?: Grade;
};

export function GradeRadio({ translation, ...props }: GradeRadio) {
  const fields = [
    { value: Grade.A, label: translation?.(Grade.A) },
    { value: Grade.B, label: translation?.(Grade.B) },
    { value: Grade.C, label: translation?.(Grade.C) },
    { value: Grade.D, label: translation?.(Grade.D) },
  ];

  return <ResetableRadioGroup size="lg" radios={fields} {...props} />;
}
